import React, { Component } from "react";
import "./navbarVerticalV2.css";
import NavbarContent from "../navbarContent/navbarContent";
import packageJson from "../../../../package.json";

export default class navbarVerticalV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      version: packageJson.version,
    };
  }

  render() {
    return (
      <div className="navbar-vertical-customisation-v2 no-view-mobile">
        <NavbarContent />
        <div className="version-container">
          <span>{ `V${this.state.version}` } </span>
        </div>
      </div>
    );
  }
}
